import Highcharts from 'highcharts';

/**
 * Custom Highcharts theme to replace GlassChartTheme from glass-design-library
 * This theme provides a clean, professional look for all charts
 */
export const customHighchartsTheme = (options: Highcharts.Options): Highcharts.Options => {
  const baseTheme: Highcharts.Options = {
    colors: ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884d8', '#82ca9d', '#ffc658', '#8dd1e1'],
    chart: {
      backgroundColor: '#ffffff',
      style: {
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      },
    },
    title: {
      style: {
        color: '#333333',
        fontSize: '18px',
        fontWeight: 'bold',
      },
    },
    subtitle: {
      style: {
        color: '#666666',
        fontSize: '14px',
      },
    },
    xAxis: {
      gridLineColor: '#e6e6e6',
      labels: {
        style: {
          color: '#666666',
        },
      },
      lineColor: '#cccccc',
      tickColor: '#cccccc',
      title: {
        style: {
          color: '#666666',
        },
      },
    },
    yAxis: {
      gridLineColor: '#e6e6e6',
      labels: {
        style: {
          color: '#666666',
        },
      },
      lineColor: '#cccccc',
      tickColor: '#cccccc',
      title: {
        style: {
          color: '#666666',
        },
      },
    },
    legend: {
      align: 'left',
      verticalAlign: 'top',
      layout: 'horizontal',
      itemStyle: {
        color: '#333333',
      },
      itemHoverStyle: {
        color: '#000000',
      },
    },
    tooltip: {
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      borderColor: '#cccccc',
      style: {
        color: '#333333',
      },
    },
    plotOptions: {
      series: {
        dataLabels: {
          color: '#333333',
        },
      },
    },
    credits: {
      enabled: false,
    },
  };

  // Deep merge the base theme with the provided options using Highcharts.merge
  return Highcharts.merge<Highcharts.Options>(baseTheme, options);
};

/**
 * Note: Highcharts.merge is used to deep-merge the base theme with any
 * provided options. No custom merge helper is required here.
 */
